export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/domains/evaluation_type/index.js